// http请求状态码
const HttpStatus = {
  Fail: 0,
  Success: 1,
  ConfirmIsContinue: 2,
  Error: 3
};

export default HttpStatus;
